

























































































import Vue from "vue";

// Model
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { AddOrganizationCommand } from "@/model/communication/organizations/AddOrganizationCommand";
import { Organization } from "@/model/data/organizations/Organization";
import { DeleteOrganizationCommand, DeleteOrganizationReqData } from "@/model/communication/organizations/DeleteOrganizationCommand";
import { ADLegacyParams, AzureADParams, LoginMode, LoginModeType, loginModeTypeEnumLabel } from "@/model/data/organizations/LoginMode";

export default Vue.extend({
    data() {
        return {
            LoginModeType,
            saving: false,
            showSuccessAlert: false,
            showErrorAlert: false,
            organizationNewName: null,
            showAreYouSureDialog: false,
            newLoginModes: [],
            newADLegacyParams: null,
            newAzureADParams: null,
        };
    },
    props: {
        organization: { type: Object as () => Organization, required: true },
    },
    computed: {
        saveable() {
            return this.saving || this.organizationNewName == null || this.organizationNewName.trim().length == 0 ? false : true;
        },

        availableLoginModes() {
            var res = [];

            Object.keys(LoginModeType)
                .filter((v) => isNaN(Number(v)))
                .forEach((key) => {
                    res.push({ value: key, text: this.$t(this.loginModeTypeEnumLabel(LoginModeType[key])) });
                });
            return res;
        },

        isADLegacyEnabled() {
            return this.newLoginModes.some((l) => l.type == LoginModeType.ADLegacy && l.enabled);
        },

        isAzureADEnabled() {
            return this.newLoginModes.some((l) => l.type == LoginModeType.AzureAD && l.enabled);
        },
    },
    watch: {
        organization(value) {
            this.reset();
        },

        isADLegacyEnabled(newValue) {
            if (newValue && this.newLoginModes.some((l) => l.type == LoginModeType.AzureAD)) this.newLoginModes.filter((l) => l.type == LoginModeType.AzureAD)[0].enabled = false;
        },

        isAzureADEnabled(newValue) {
            if (newValue && this.newLoginModes.some((l) => l.type == LoginModeType.ADLegacy)) this.newLoginModes.filter((l) => l.type == LoginModeType.ADLegacy)[0].enabled = false;
        },
    },
    methods: {
        loginModeTypeEnumLabel,

        async addOrganization() {
            try {
                if (!this.saving) {
                    this.saving = true;

                    var organization = new Organization();
                    organization.name = this.organizationNewName;
                    organization.folderId = this.organization.folderId;

                    organization.loginModes = [];
                    this.newLoginModes.forEach((newLoginMode: LoginMode) => {
                        switch (newLoginMode.type) {
                            case LoginModeType.ADLegacy:
                                newLoginMode.params = JSON.stringify(this.newADLegacyParams);
                                break;
                            case LoginModeType.AzureAD:
                                newLoginMode.params = JSON.stringify(this.newAzureADParams);
                                break;
                            default:
                                break;
                        }
                        organization.loginModes.push(newLoginMode);
                    });

                    var res = await new AddOrganizationCommand(organization).execute();
                    if (res.responseStatus == ApiResponseStatusEnum.Success && res.responseString != "GenericError") {
                        this.$emit("close");
                    } else this.showErrorAlert = true;

                    this.saving = false;
                }
            } catch (error) {
                console.log("Something went wrong in editOrganization()", error);
                this.saving = false;
            }
        },

        async deleteOrganization() {
            try {
                this.showDeleteProfileDialog = false;
                const res = await new DeleteOrganizationCommand(new DeleteOrganizationReqData(this.organization.folderId)).execute();
                if (res.responseStatus == ApiResponseStatusEnum.Success) {
                    this.$emit("getOrganizations");
                } else this.showErrorAlert = true;
            } catch (error) {
                console.log("Something went wrong during DeleteClientProfileCommand execution: ", error);
            }
        },

        reset() {
            this.saving = false;
            this.showSuccessAlert = false;
            this.showErrorAlert = false;
            this.organizationNewName = this.organization.name;

            this.newLoginModes = [];
            Object.keys(LoginModeType)
                .filter((v) => isNaN(Number(v)))
                .forEach((element) => {
                    var tempLoginMode = new LoginMode();
                    tempLoginMode.type = LoginModeType[element];
                    tempLoginMode.enabled = false;
                    tempLoginMode.params = null;
                    this.newLoginModes.push(tempLoginMode);
                });

            this.newADLegacyParams = new ADLegacyParams();
            this.newAzureADParams = new AzureADParams();

            if (this.organization.loginModes != null)
                this.organization.loginModes.forEach((loginMode: LoginMode) => {
                    if (this.newLoginModes.some((l) => l.type == loginMode.type)) {
                        this.newLoginModes.filter((l) => l.type == loginMode.type)[0].enabled = loginMode.enabled;
                        if (loginMode.params != null) {
                            try {
                                switch (loginMode.type) {
                                    case LoginModeType.ADLegacy:
                                        this.newADLegacyParams = JSON.parse(loginMode.params);
                                        break;
                                    case LoginModeType.AzureAD:
                                        this.newAzureADParams = JSON.parse(loginMode.params);
                                        break;
                                    default:
                                        break;
                                }
                            } catch (error) {
                                console.error("Error parsing these loginMode params: ", loginMode);
                            }
                        }
                    }
                });

            this.showAreYouSureDialog = false;
        },
    },
    mounted() {
        this.reset();
    },
});
